/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { icons } from '../../../../../assets';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { openLabelEditor } from '../../../../Table/actions/tableActions';
import { EEditableLabel } from '../../../../Table/components/footerModal/LabelEditor/labelEditorTypes';
import { TableFooterNameType } from '../../../../Table/types/tableTypes';
import { TTableButtonsGetTranslation, TUseTableFooterButtonsOnboarding } from '../useTableFooterButtons';

const useTableFooterButtonLabelEdit = (
    getTranslation: TTableButtonsGetTranslation,
    tableFooterName: TableFooterNameType,
) => {
    const dispatch = useDispatch();

    return {
        className: 'table-footer__link link-edit',
        dataName: 'edit',
        icon: icons.editIconSmall,
        id: AccessComponentKeyEnum.FooterButtonLabels,
        ...mapTableFooterNameToOnboarding[tableFooterName],
        ...getTranslation(AccessComponentKeyEnum.FooterButtonLabels),

        onClick: useCallback(() => {
            const type = mapTableFooterNameToLabelType[tableFooterName];
            if (type) {
                dispatch(openLabelEditor(type));
            }
        }, [dispatch, tableFooterName]),
    };
};

const mapTableFooterNameToLabelType: Partial<{ [key in TableFooterNameType]: EEditableLabel }> = {
    [TableFooterNameType.subscriberId]: EEditableLabel.subscriberId,
    [TableFooterNameType.subscriberMobile]: EEditableLabel.mobile,
};

const mapTableFooterNameToOnboarding: TUseTableFooterButtonsOnboarding = {
    [TableFooterNameType.subscriberMobile]: {
        onboarding: EOnboardingComponentsId.subscriberTableFooterButtonLabelEdit,
    },
};

export default useTableFooterButtonLabelEdit;
